import { render, staticRenderFns } from "./radio-button-wrapper.code.md?vue&type=template&id=47241064&"
import script from "./radio-button-wrapper.code.md?vue&type=script&lang=ts&"
export * from "./radio-button-wrapper.code.md?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../storefront/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports